import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import { signup } from '../utils/paymentApi';
import { getGuestAccessCode } from '../utils/guestStorage';
import { showError } from '../utils/snackbar';
import './Auth.css';

// Sign up with email — OTP verification next
class Signup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: '',
      lastName: '',
      email: '',
      birthDate: '',
      password: '',
      confirmPassword: '',
      guestAccessCode: getGuestAccessCode() || '',
      loading: false,
    };
  }

  handleChange = (field) => (event) => {
    this.setState({ [field]: event.target.value });
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    if (this.state.password !== this.state.confirmPassword) {
      showError('Passwords do not match');
      return;
    }
    try {
      this.setState({ loading: true });
      await signup({
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        email: this.state.email,
        birthDate: this.state.birthDate || undefined,
        password: this.state.password,
        guestAccessCode: this.state.guestAccessCode || undefined,
      });
      window.location.href = `/verify-email?email=${encodeURIComponent(this.state.email)}`;
    } catch (e) {
      showError(_.get(e, 'message', 'Sign up failed'));
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const s = this.state;
    return (
      <div className="auth-page">
        <div className="auth-card">
          <h1 className="auth-title">Create account</h1>
          <p className="auth-sub">Optional — guest checkout still works without signup.</p>
          <form onSubmit={this.handleSubmit}>
            <label htmlFor="su-first">First name</label>
            <input id="su-first" value={s.firstName} onChange={this.handleChange('firstName')} />
            <label htmlFor="su-last">Last name</label>
            <input id="su-last" value={s.lastName} onChange={this.handleChange('lastName')} />
            <label htmlFor="su-email">Email</label>
            <input
              id="su-email"
              type="email"
              value={s.email}
              onChange={this.handleChange('email')}
              required
            />
            <label htmlFor="su-birth">Birth date</label>
            <input
              id="su-birth"
              type="date"
              value={s.birthDate}
              onChange={this.handleChange('birthDate')}
            />
            <label htmlFor="su-pass">Password</label>
            <input
              id="su-pass"
              type="password"
              value={s.password}
              onChange={this.handleChange('password')}
              required
              minLength={8}
            />
            <label htmlFor="su-pass2">Confirm password</label>
            <input
              id="su-pass2"
              type="password"
              value={s.confirmPassword}
              onChange={this.handleChange('confirmPassword')}
              required
              minLength={8}
            />
            <label htmlFor="su-access">Guest Access Code (optional — link past orders)</label>
            <input
              id="su-access"
              value={s.guestAccessCode}
              onChange={this.handleChange('guestAccessCode')}
            />
            <button type="submit" className="auth-cta" disabled={s.loading}>
              {s.loading ? 'Creating…' : 'Sign up'}
            </button>
          </form>
          <p className="auth-footer">
            Already have an account? <Link to="/login">Log in</Link>
          </p>
        </div>
      </div>
    );
  }
}

export default Signup;
